import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CanActivateProdutividade } from './can-activate-produtividade';
import { ProdutividadeViewComponent } from '../views/view';
import { ProdutividadeMainViewComponent } from '../views/main';


@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: '',
                canActivateChild: [CanActivateProdutividade],
                component: ProdutividadeViewComponent,
                children: [
                    {
                        path: '',
                        component: ProdutividadeMainViewComponent
                    }
                    // {path: '', redirectTo: '', pathMatch: 'full'}
                ]
            }
        ])
    ],
    exports: [
        RouterModule
    ],
    providers: [
        CanActivateProdutividade
    ]
})
export class ProdutividadeRoutingModule { }
